type AggregateChapterCounts = {
    accRelevant: number;
    accIncomplete: number;
    total: number;
};

interface ICountedChapter {
    numberRelevantCompleted?: number;
    numberRelevantOpen?: number;
    numberIrrelevantOpen?: number;
    numberIrrelevantCompleted?: number;
}

export const aggregateChapterCounts = (chapters: ICountedChapter[]): AggregateChapterCounts => {
    const accRelevantOpen = chapters.reduce((acc, current) => acc + (current?.numberRelevantOpen ?? 0), 0);
    const accRelevantCompleted = chapters.reduce((acc, current) => acc + (current?.numberRelevantCompleted ?? 0), 0);
    const accRelevant = accRelevantOpen + accRelevantCompleted;
    const total = chapters.reduce(
        (acc, current) =>
            acc +
            (current?.numberRelevantOpen ?? 0) +
            (current?.numberRelevantCompleted ?? 0) +
            (current?.numberIrrelevantOpen ?? 0) +
            (current?.numberIrrelevantCompleted ?? 0),
        0
    );
    const accIncomplete = chapters.reduce(
        (acc, current) => acc + (current?.numberRelevantOpen ?? 0) + (current?.numberIrrelevantOpen ?? 0),
        0
    );
    return { accRelevant, accIncomplete, total };
};
